export const DEFAULT_HORIZONTAL_PADDING = 16;
